import i18n from '@dms/i18n';
import {SettingsTemplate} from '@dms/settings/shared';

import {ChatSettingsForm} from './components/ChatSettingsForm';

export function ChatSettings() {
  return (
    <SettingsTemplate
      header={{title: i18n.t('entity.chatSettings.labels.pageTitle')}}
      data-testid="sales-chat-settings"
      description={i18n.t('entity.chatSettings.labels.description')}
    >
      <ChatSettingsForm />
    </SettingsTemplate>
  );
}
